import { cache, initialVaultCache, } from "./cache";
import { wagmiConfig as config, } from "@wagmiconfig";
import { getLatestPrice,} from "@bracket/contractor-next/pricing";

export const latestPricePricingEth = async (): Promise<number> => {

	const now = Date.now();
	const { time, value, since, } = cache.latest_price_eth;

	if(since > now - time) {
		return value;
	}

	const next = await getLatestPrice({ token: "ETH_USD", config, });
  cache.latest_price_eth.since = Date.now();
  cache.latest_price_eth.value = next;

	return next;
}

export const latestPriceEth = async (): Promise<number> => {

	const now = Date.now();
	const { time, value, since, } = cache.latest_price_eth;

	if(since > now - time) {
		return value;
	}

	const { VITE_ALCHEMY_API_KEY, } = import.meta.env;
	try {
		const response = await fetch(`https://api.g.alchemy.com/prices/v1/${VITE_ALCHEMY_API_KEY}/tokens/by-symbol?symbols=ETH`);
		const result = await response.json();
		const next = Number(result.data[0].prices[0].value);
		cache.latest_price_eth.since = Date.now();
		cache.latest_price_eth.value = next;
		return next;
	}
	catch(err) {
		const { value, } = cache.latest_price_eth;
		console.warn(`failed gaining updated ethereum price , using cached value -- ${value}`);
		console.warn("error:", err instanceof Error ? err.message : "no error message");
		console.trace();
		return value;
	}

}
